// // AuthChecker.jsx
// import { useEffect } from 'react';
// import Cookies from 'js-cookie';

// const AuthChecker = ({ children }) => {
//   useEffect(() => {
//     // Check authentication BEFORE any React Router code runs
//     const superAdminToken = Cookies.get('superAdminToken');
//     const authToken = Cookies.get('authToken');
//     const currentPath = window.location.pathname;
    
//     console.log("AuthChecker - Current path:", currentPath);
//     console.log("AuthChecker - SuperAdmin token:", !!superAdminToken);
//     console.log("AuthChecker - Admin token:", !!authToken);
    
//     // If on login page with tokens, redirect
//     if (currentPath === '/login' || currentPath === '/') {
//       if (superAdminToken) {
//         console.log("AuthChecker - Super admin on login, redirecting to dashboard");
//         window.location.replace('/dashboard');
//         return;
//       }
//       if (authToken) {
//         console.log("AuthChecker - Admin on login, redirecting to home");
//         window.location.replace('/home');
//         return;
//       }
//     }
    
//     // If on protected pages without tokens, redirect to login
//     if (currentPath.startsWith('/dashboard') && !superAdminToken) {
//       console.log("AuthChecker - No super admin token, redirecting to login");
//       window.location.replace('/login');
//       return;
//     }
    
//     if (!currentPath.startsWith('/login') && 
//         !currentPath.startsWith('/signup') && 
//         !currentPath.startsWith('/dashboard') && 
//         !authToken && !superAdminToken) {
//       console.log("AuthChecker - No token, redirecting to login");
//       window.location.replace('/login');
//       return;
//     }
//   }, []);

//   return children;
// };

// export default AuthChecker;

// AuthChecker.jsx
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';

const AuthChecker = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check authentication
    const superAdminToken = Cookies.get('superAdminToken');
    const authToken = Cookies.get('authToken');
    const currentPath = location.pathname;
    
    console.log("AuthChecker - Current path:", currentPath);
    console.log("AuthChecker - SuperAdmin token:", !!superAdminToken);
    console.log("AuthChecker - Admin token:", !!authToken);
    
    // List of public routes
    const publicRoutes = ['/login', '/signup'];
    
    // If on login/signup page with valid tokens, redirect
    if (publicRoutes.includes(currentPath)) {
      if (superAdminToken) {
        console.log("AuthChecker - Super admin on login, redirecting to dashboard");
        navigate('/dashboard', { replace: true });
        return;
      }
      if (authToken) {
        console.log("AuthChecker - Admin on login, redirecting to home");
        navigate('/home', { replace: true });
        return;
      }
    }
    
    // If on protected page without tokens, redirect to login
    const isProtectedRoute = !publicRoutes.includes(currentPath);
    
    if (isProtectedRoute) {
      // Super admin routes
      if (currentPath.startsWith('/dashboard') || 
          currentPath.startsWith('/super-admin/')) {
        if (!superAdminToken) {
          console.log("AuthChecker - No super admin token, redirecting to login");
          navigate('/login', { replace: true });
          return;
        }
      } 
      // Regular admin routes
      else if (!authToken && !superAdminToken) {
        console.log("AuthChecker - No token, redirecting to login");
        navigate('/login', { replace: true });
        return;
      }
    }
  }, [location.pathname, navigate]); // Re-run when path changes

  return children;
};

export default AuthChecker;